<div class="content-container">
  <div class="picture-container">
    <div class="container">
      <img src="../../assets/seatformeasurementstoragebetween.svg" class="img-size" />
    </div>
    <div class="container">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>H1</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="baseDimension?.box?.height"
          (ngModelChange)="baseDimension.box.height = $event" autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>W1</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="seatWithStorage?.w1"
          (ngModelChange)="seatWithStorage.w1 = $event" autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>S1</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="seatWithStorage?.s1"
          (ngModelChange)="seatWithStorage.s1 = $event" autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>W2</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="seatWithStorage?.w2"
          (ngModelChange)="seatWithStorage.w2 = $event" autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>W3</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="seatWithStorage?.w3"
          (ngModelChange)="seatWithStorage.w3 = $event" autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>H2</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="seatWithStorage?.h2"
          (ngModelChange)="seatWithStorage.h2 = $event" autocomplete="off">
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>H3</mat-label>
        <input matInput type="number" (keypress)="integerOnly($event)" [ngModel]="seatWithStorage?.h3"
          (ngModelChange)="seatWithStorage.h3 = $event" autocomplete="off">
      </mat-form-field>
    </div>
  </div>
  <div class="container">
    <!-- <mat-form-field appearance="outline" class="form-field">
        <mat-label>Seat capacity</mat-label>
        <input matInput type="number" step="0.5" min="1" [ngModel]="seat?.seatAmount"
          (ngModelChange)="seat.seatAmount = $event" [disabled]="seat?.seatAmountEditable === false" autocomplete="off">
      </mat-form-field>  -->
    <mat-form-field class="form-field">
      <mat-label>Seat capacity</mat-label>
      <mat-select class="text-right" [disabled]="seat?.seatAmountEditable === false" [value]="seat?.seatAmount"
        (selectionChange)="changeSeatCapacity($event.value)">
        <mat-option class="select-without-checkbox" *ngFor="let capacity of seatCapacities" [value]="capacity">
          {{capacity}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="seatWithStorage?.groundSupport"
      (ngModelChange)="seatWithStorage.groundSupport = $event" class="margin-right form-field">
      Floor support
    </mat-checkbox>
    <div *ngIf="show">
      <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="seatWithStorage?.tableForOwnSeat"
        (ngModelChange)="seatWithStorage.tableForOwnSeat = $event" class="margin-right form-field">
        Table For Your Own Place
      </mat-checkbox>
      <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="seatWithStorage?.socket"
        (ngModelChange)="seatWithStorage.socket = $event" class="margin-right form-field">
        Socket
      </mat-checkbox>
      <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="seatWithStorage?.armrestAvailable"
        (ngModelChange)="seatWithStorage.armrestAvailable = $event" class="margin-right form-field">
        Armrest Available
      </mat-checkbox>
      <mat-checkbox [ngModelOptions]="{standalone: true}" *ngIf="armrestBetweenSeat != null"
        [ngModel]="armrestBetweenSeat?.armrestBetweenSeats"
        (ngModelChange)="armrestBetweenSeat.armrestBetweenSeats = $event" class="margin-right form-field">
        Armrest In Between
      </mat-checkbox>
    </div>
  </div>
</div>